const countryvalues = [
    {
      name: 'Afghanistan',
      label: '+93 (AF)',
      value: '+93'
    },
    {
      name: 'Aland Islands',
      label: '+358 (AX)',
      value: '+358'
    },
    {
      name: 'Albania',
      label: '+355 (AL)',
      value: '+355'
    },
    {
      name: 'Algeria',
      label: '+213 (DZ)',
      value: '+213'
    },
    {
      name: 'American Samoa',
      label: '+1684 (AS)',
      value: '+1684'
    },
    {
      name: 'Andorra',
      label: '+376 (AD)',
      value: '+376'
    },
    {
      name: 'Angola',
      label: '+244 (AO)',
      value: '+244'
    },
    {
      name: 'Anguilla',
      label: '+1264 (AI)',
      value: '+1264'
    },
    {
      name: 'Antarctica',
      label: '+672 (AQ)',
      value: '+672'
    },
    {
      name: 'Antigua and Barbuda',
      label: '+1268 (AG)',
      value: '+1268'
    },
    {
      name: 'Argentina',
      label: '+54 (AR)',
      value: '+54'
    },
    {
      name: 'Armenia',
      label: '+374 (AM)',
      value: '+374'
    },
    {
      name: 'Aruba',
      label: '+297 (AW)',
      value: '+297'
    },
    {
      name: 'Australia',
      label: '+61 (AU)',
      value: '+61'
    },
    {
      name: 'Austria',
      label: '+43 (AT)',
      value: '+43'
    },
    {
      name: 'Azerbaijan',
      label: '+994 (AZ)',
      value: '+994'
    },
    {
      name: 'Bahamas',
      label: '+1242 (BS)',
      value: '+1242'
    },
    {
      name: 'Bahrain',
      label: '+973 (BH)',
      value: '+973'
    },
    {
      name: 'Bangladesh',
      label: '+880 (BD)',
      value: '+880'
    },
    {
      name: 'Barbados',
      label: '+1246 (BB)',
      value: '+1246'
    },
    {
      name: 'Belarus',
      label: '+375 (BY)',
      value: '+375'
    },
    {
      name: 'Belgium',
      label: '+32 (BE)',
      value: '+32'
    },
    {
      name: 'Belize',
      label: '+501 (BZ)',
      value: '+501'
    },
    {
      name: 'Benin',
      label: '+229 (BJ)',
      value: '+229'
    },
    {
      name: 'Bermuda',
      label: '+1441 (BM)',
      value: '+1441'
    },
    {
      name: 'Bhutan',
      label: '+975 (BT)',
      value: '+975'
    },
    {
      name: 'Bolivia, Plurinational State of',
      label: '+591 (BO)',
      value: '+591'
    },
    {
      name: 'Bosnia and Herzegovina',
      label: '+387 (BA)',
      value: '+387'
    },
    {
      name: 'Botswana',
      label: '+267 (BW)',
      value: '+267'
    },
    {
      name: 'Brazil',
      label: '+55 (BR)',
      value: '+55'
    },
    {
      name: 'British Indian Ocean Territory',
      label: '+246 (IO)',
      value: '+246'
    },
    {
      name: 'Brunei Darussalam',
      label: '+673 (BN)',
      value: '+673'
    },
    {
      name: 'Bulgaria',
      label: '+359 (BG)',
      value: '+359'
    },
    {
      name: 'Burkina Faso',
      label: '+226 (BF)',
      value: '+226'
    },
    {
      name: 'Burundi',
      label: '+257 (BI)',
      value: '+257'
    },
    {
      name: 'Cambodia',
      label: '+855 (KH)',
      value: '+855'
    },
    {
      name: 'Cameroon',
      label: '+237 (CM)',
      value: '+237'
    },
    {
      name: 'Canada',
      label: '+1 (CA)',
      value: '+1'
    },
    {
      name: 'Cape Verde',
      label: '+238 (CV)',
      value: '+238'
    },
    {
      name: 'Cayman Islands',
      label: '+345 (KY)',
      value: '+345'
    },
    {
      name: 'Central African Republic',
      label: '+236 (CF)',
      value: '+236'
    },
    {
      name: 'Chad',
      label: '+235 (TD)',
      value: '+235'
    },
    {
      name: 'Chile',
      label: '+56 (CL)',
      value: '+56'
    },
    {
      name: 'China',
      label: '+86 (CN)',
      value: '+86'
    },
    {
      name: 'Christmas Island',
      label: '+61 (CX)',
      value: '+61'
    },
    {
      name: 'Cocos (Keeling) Islands',
      label: '+61 (CC)',
      value: '+61'
    },
    {
      name: 'Colombia',
      label: '+57 (CO)',
      value: '+57'
    },
    {
      name: 'Comoros',
      label: '+269 (KM)',
      value: '+269'
    },
    {
      name: 'Congo',
      label: '+242 (CG)',
      value: '+242'
    },
    {
      name: 'Congo, The Democratic Republic of the Congo',
      label: '+243 (CD)',
      value: '+243'
    },
    {
      name: 'Cook Islands',
      label: '+682 (CK)',
      value: '+682'
    },
    {
      name: 'Costa Rica',
      label: '+506 (CR)',
      value: '+506'
    },
    {
      name: 'Cote d\'Ivoire',
      label: '+225 (CI)',
      value: '+225'
    },
    {
      name: 'Croatia',
      label: '+385 (HR)',
      value: '+385'
    },
    {
      name: 'Cuba',
      label: '+53 (CU)',
      value: '+53'
    },
    {
      name: 'Cyprus',
      label: '+357 (CY)',
      value: '+357'
    },
    {
      name: 'Czech Republic',
      label: '+420 (CZ)',
      value: '+420'
    },
    {
      name: 'Denmark',
      label: '+45 (DK)',
      value: '+45'
    },
    {
      name: 'Djibouti',
      label: '+253 (DJ)',
      value: '+253'
    },
    {
      name: 'Dominica',
      label: '+1767 (DM)',
      value: '+1767'
    },
    {
      name: 'Dominican Republic',
      label: '+1849 (DO)',
      value: '+1849'
    },
    {
      name: 'Ecuador',
      label: '+593 (EC)',
      value: '+593'
    },
    {
      name: 'Egypt',
      label: '+20 (EG)',
      value: '+20'
    },
    {
      name: 'El Salvador',
      label: '+503 (SV)',
      value: '+503'
    },
    {
      name: 'Equatorial Guinea',
      label: '+240 (GQ)',
      value: '+240'
    },
    {
      name: 'Eritrea',
      label: '+291 (ER)',
      value: '+291'
    },
    {
      name: 'Estonia',
      label: '+372 (EE)',
      value: '+372'
    },
    {
      name: 'Ethiopia',
      label: '+251 (ET)',
      value: '+251'
    },
    {
      name: 'Falkland Islands (Malvinas)',
      label: '+500 (FK)',
      value: '+500'
    },
    {
      name: 'Faroe Islands',
      label: '+298 (FO)',
      value: '+298'
    },
    {
      name: 'Fiji',
      label: '+679 (FJ)',
      value: '+679'
    },
    {
      name: 'Finland',
      label: '+358 (FI)',
      value: '+358'
    },
    {
      name: 'France',
      label: '+33 (FR)',
      value: '+33'
    },
    {
      name: 'French Guiana',
      label: '+594 (GF)',
      value: '+594'
    },
    {
      name: 'French Polynesia',
      label: '+689 (PF)',
      value: '+689'
    },
    {
      name: 'Gabon',
      label: '+241 (GA)',
      value: '+241'
    },
    {
      name: 'Gambia',
      label: '+220 (GM)',
      value: '+220'
    },
    {
      name: 'Georgia',
      label: '+995 (GE)',
      value: '+995'
    },
    {
      name: 'Germany',
      label: '+49 (DE)',
      value: '+49'
    },
    {
      name: 'Ghana',
      label: '+233 (GH)',
      value: '+233'
    },
    {
      name: 'Gibraltar',
      label: '+350 (GI)',
      value: '+350'
    },
    {
      name: 'Greece',
      label: '+30 (GR)',
      value: '+30'
    },
    {
      name: 'Greenland',
      label: '+299 (GL)',
      value: '+299'
    },
    {
      name: 'Grenada',
      label: '+1473 (GD)',
      value: '+1473'
    },
    {
      name: 'Guadeloupe',
      label: '+590 (GP)',
      value: '+590'
    },
    {
      name: 'Guam',
      label: '+1671 (GU)',
      value: '+1671'
    },
    {
      name: 'Guatemala',
      label: '+502 (GT)',
      value: '+502'
    },
    {
      name: 'Guernsey',
      label: '+44 (GG)',
      value: '+44'
    },
    {
      name: 'Guinea',
      label: '+224 (GN)',
      value: '+224'
    },
    {
      name: 'Guinea-Bissau',
      label: '+245 (GW)',
      value: '+245'
    },
    {
      name: 'Guyana',
      label: '+595 (GY)',
      value: '+595'
    },
    {
      name: 'Haiti',
      label: '+509 (HT)',
      value: '+509'
    },
    {
      name: 'Holy See (Vatican City State)',
      label: '+379 (VA)',
      value: '+379'
    },
    {
      name: 'Honduras',
      label: '+504 (HN)',
      value: '+504'
    },
    {
      name: 'Hong Kong',
      label: '+852 (HK)',
      value: '+852'
    },
    {
      name: 'Hungary',
      label: '+36 (HU)',
      value: '+36'
    },
    {
      name: 'Iceland',
      label: '+354 (IS)',
      value: '+354'
    },
    {
      name: 'India',
      label: '+91 (IN)',
      value: '+91'
    },
    {
      name: 'Indonesia',
      label: '+62 (ID)',
      value: '+62'
    },
    {
      name: 'Iran, Islamic Republic of Persian Gulf',
      label: '+98 (IR)',
      value: '+98'
    },
    {
      name: 'Iraq',
      label: '+964 (IQ)',
      value: '+964'
    },
    {
      name: 'Ireland',
      label: '+353 (IE)',
      value: '+353'
    },
    {
      name: 'Isle of Man',
      label: '+44 (IM)',
      value: '+44'
    },
    {
      name: 'Israel',
      label: '+972 (IL)',
      value: '+972'
    },
    {
      name: 'Italy',
      label: '+39 (IT)',
      value: '+39'
    },
    {
      name: 'Jamaica',
      label: '+1876 (JM)',
      value: '+1876'
    },
    {
      name: 'Japan',
      label: '+81 (JP)',
      value: '+81'
    },
    {
      name: 'Jersey',
      label: '+44 (JE)',
      value: '+44'
    },
    {
      name: 'Jordan',
      label: '+962 (JO)',
      value: '+962'
    },
    {
      name: 'Kazakhstan',
      label: '+7 (KZ)',
      value: '+7'
    },
    {
      name: 'Kenya',
      label: '+254 (KE)',
      value: '+254'
    },
    {
      name: 'Kiribati',
      label: '+686 (KI)',
      value: '+686'
    },
    {
      name: 'Korea, Democratic People\'s Republic of Korea',
      label: '+850 (KP)',
      value: '+850'
    },
    {
      name: 'Korea, Republic of South Korea',
      label: '+82 (KR)',
      value: '+82'
    },
    {
      name: 'Kuwait',
      label: '+965 (KW)',
      value: '+965'
    },
    {
      name: 'Kyrgyzstan',
      label: '+996 (KG)',
      value: '+996'
    },
    {
      name: 'Laos',
      label: '+856 (LA)',
      value: '+856'
    },
    {
      name: 'Latvia',
      label: '+371 (LV)',
      value: '+371'
    },
    {
      name: 'Lebanon',
      label: '+961 (LB)',
      value: '+961'
    },
    {
      name: 'Lesotho',
      label: '+266 (LS)',
      value: '+266'
    },
    {
      name: 'Liberia',
      label: '+231 (LR)',
      value: '+231'
    },
    {
      name: 'Libyan Arab Jamahiriya',
      label: '+218 (LY)',
      value: '+218'
    },
    {
      name: 'Liechtenstein',
      label: '+423 (LI)',
      value: '+423'
    },
    {
      name: 'Lithuania',
      label: '+370 (LT)',
      value: '+370'
    },
    {
      name: 'Luxembourg',
      label: '+352 (LU)',
      value: '+352'
    },
    {
      name: 'Macao',
      label: '+853 (MO)',
      value: '+853'
    },
    {
      name: 'Macedonia',
      label: '+389 (MK)',
      value: '+389'
    },
    {
      name: 'Madagascar',
      label: '+261 (MG)',
      value: '+261'
    },
    {
      name: 'Malawi',
      label: '+265 (MW)',
      value: '+265'
    },
    {
      name: 'Malaysia',
      label: '+60 (MY)',
      value: '+60'
    },
    {
      name: 'Maldives',
      label: '+960 (MV)',
      value: '+960'
    },
    {
      name: 'Mali',
      label: '+223 (ML)',
      value: '+223'
    },
    {
      name: 'Malta',
      label: '+356 (MT)',
      value: '+356'
    },
    {
      name: 'Marshall Islands',
      label: '+692 (MH)',
      value: '+692'
    },
    {
      name: 'Martinique',
      label: '+596 (MQ)',
      value: '+596'
    },
    {
      name: 'Mauritania',
      label: '+222 (MR)',
      value: '+222'
    },
    {
      name: 'Mauritius',
      label: '+230 (MU)',
      value: '+230'
    },
    {
      name: 'Mayotte',
      label: '+262 (YT)',
      value: '+262'
    },
    {
      name: 'Mexico',
      label: '+52 (MX)',
      value: '+52'
    },
    {
      name: 'Micronesia, Federated States of Micronesia',
      label: '+691 (FM)',
      value: '+691'
    },
    {
      name: 'Moldova',
      label: '+373 (MD)',
      value: '+373'
    },
    {
      name: 'Monaco',
      label: '+377 (MC)',
      value: '+377'
    },
    {
      name: 'Mongolia',
      label: '+976 (MN)',
      value: '+976'
    },
    {
      name: 'Montenegro',
      label: '+382 (ME)',
      value: '+382'
    },
    {
      name: 'Montserrat',
      label: '+1664 (MS)',
      value: '+1664'
    },
    {
      name: 'Morocco',
      label: '+212 (MA)',
      value: '+212'
    },
    {
      name: 'Mozambique',
      label: '+258 (MZ)',
      value: '+258'
    },
    {
      name: 'Myanmar',
      label: '+95 (MM)',
      value: '+95'
    },
    {
      name: 'Namibia',
      label: '+264 (NA)',
      value: '+264'
    },
    {
      name: 'Nauru',
      label: '+674 (NR)',
      value: '+674'
    },
    {
      name: 'Nepal',
      label: '+977 (NP)',
      value: '+977'
    },
    {
      name: 'Netherlands',
      label: '+31 (NL)',
      value: '+31'
    },
    {
      name: 'Netherlands Antilles',
      label: '+599 (AN)',
      value: '+599'
    },
    {
      name: 'New Caledonia',
      label: '+687 (NC)',
      value: '+687'
    },
    {
      name: 'New Zealand',
      label: '+64 (NZ)',
      value: '+64'
    },
    {
      name: 'Nicaragua',
      label: '+505 (NI)',
      value: '+505'
    },
    {
      name: 'Niger',
      label: '+227 (NE)',
      value: '+227'
    },
    {
      name: 'Nigeria',
      label: '+234 (NG)',
      value: '+234'
    },
    {
      name: 'Niue',
      label: '+683 (NU)',
      value: '+683'
    },
    {
      name: 'Norfolk Island',
      label: '+672 (NF)',
      value: '+672'
    },
    {
      name: 'Northern Mariana Islands',
      label: '+1670 (MP)',
      value: '+1670'
    },
    {
      name: 'Norway',
      label: '+47 (NO)',
      value: '+47'
    },
    {
      name: 'Oman',
      label: '+968 (OM)',
      value: '+968'
    },
    {
      name: 'Pakistan',
      label: '+92 (PK)',
      value: '+92'
    },
    {
      name: 'Palau',
      label: '+680 (PW)',
      value: '+680'
    },
    {
      name: 'Palestinian Territory, Occupied',
      label: '+970 (PS)',
      value: '+970'
    },
    {
      name: 'Panama',
      label: '+507 (PA)',
      value: '+507'
    },
    {
      name: 'Papua New Guinea',
      label: '+675 (PG)',
      value: '+675'
    },
    {
      name: 'Paraguay',
      label: '+595 (PY)',
      value: '+595'
    },
    {
      name: 'Peru',
      label: '+51 (PE)',
      value: '+51'
    },
    {
      name: 'Philippines',
      label: '+63 (PH)',
      value: '+63'
    },
    {
      name: 'Pitcairn',
      label: '+872 (PN)',
      value: '+872'
    },
    {
      name: 'Poland',
      label: '+48 (PL)',
      value: '+48'
    },
    {
      name: 'Portugal',
      label: '+351 (PT)',
      value: '+351'
    },
    {
      name: 'Puerto Rico',
      label: '+1939 (PR)',
      value: '+1939'
    },
    {
      name: 'Qatar',
      label: '+974 (QA)',
      value: '+974'
    },
    {
      name: 'Romania',
      label: '+40 (RO)',
      value: '+40'
    },
    {
      name: 'Russia',
      label: '+7 (RU)',
      value: '+7'
    },
    {
      name: 'Rwanda',
      label: '+250 (RW)',
      value: '+250'
    },
    {
      name: 'Reunion',
      label: '+262 (RE)',
      value: '+262'
    },
    {
      name: 'Saint Barthelemy',
      label: '+590 (BL)',
      value: '+590'
    },
    {
      name: 'Saint Helena, Ascension and Tristan Da Cunha',
      label: '+290 (SH)',
      value: '+290'
    },
    {
      name: 'Saint Kitts and Nevis',
      label: '+1869 (KN)',
      value: '+1869'
    },
    {
      name: 'Saint Lucia',
      label: '+1758 (LC)',
      value: '+1758'
    },
    {
      name: 'Saint Martin',
      label: '+590 (MF)',
      value: '+590'
    },
    {
      name: 'Saint Pierre and Miquelon',
      label: '+508 (PM)',
      value: '+508'
    },
    {
      name: 'Saint Vincent and the Grenadines',
      label: '+1784 (VC)',
      value: '+1784'
    },
    {
      name: 'Samoa',
      label: '+685 (WS)',
      value: '+685'
    },
    {
      name: 'San Marino',
      label: '+378 (SM)',
      value: '+378'
    },
    {
      name: 'Sao Tome and Principe',
      label: '+239 (ST)',
      value: '+239'
    },
    {
      name: 'Saudi Arabia',
      label: '+966 (SA)',
      value: '+966'
    },
    {
      name: 'Senegal',
      label: '+221 (SN)',
      value: '+221'
    },
    {
      name: 'Serbia',
      label: '+381 (RS)',
      value: '+381'
    },
    {
      name: 'Seychelles',
      label: '+248 (SC)',
      value: '+248'
    },
    {
      name: 'Sierra Leone',
      label: '+232 (SL)',
      value: '+232'
    },
    {
      name: 'Singapore',
      label: '+65 (SG)',
      value: '+65'
    },
    {
      name: 'Slovakia',
      label: '+421 (SK)',
      value: '+421'
    },
    {
      name: 'Slovenia',
      label: '+386 (SI)',
      value: '+386'
    },
    {
      name: 'Solomon Islands',
      label: '+677 (SB)',
      value: '+677'
    },
    {
      name: 'Somalia',
      label: '+252 (SO)',
      value: '+252'
    },
    {
      name: 'South Africa',
      label: '+27 (ZA)',
      value: '+27'
    },
    {
      name: 'South Sudan',
      label: '+211 (SS)',
      value: '+211'
    },
    {
      name: 'South Georgia and the South Sandwich Islands',
      label: '+500 (GS)',
      value: '+500'
    },
    {
      name: 'Spain',
      label: '+34 (ES)',
      value: '+34'
    },
    {
      name: 'Sri Lanka',
      label: '+94 (LK)',
      value: '+94'
    },
    {
      name: 'Sudan',
      label: '+249 (SD)',
      value: '+249'
    },
    {
      name: 'Suriname',
      label: '+597 (SR)',
      value: '+597'
    },
    {
      name: 'Svalbard and Jan Mayen',
      label: '+47 (SJ)',
      value: '+47'
    },
    {
      name: 'Swaziland',
      label: '+268 (SZ)',
      value: '+268'
    },
    {
      name: 'Sweden',
      label: '+46 (SE)',
      value: '+46'
    },
    {
      name: 'Switzerland',
      label: '+41 (CH)',
      value: '+41'
    },
    {
      name: 'Syrian Arab Republic',
      label: '+963 (SY)',
      value: '+963'
    },
    {
      name: 'Taiwan',
      label: '+886 (TW)',
      value: '+886'
    },
    {
      name: 'Tajikistan',
      label: '+992 (TJ)',
      value: '+992'
    },
    {
      name: 'Tanzania, United Republic of Tanzania',
      label: '+255 (TZ)',
      value: '+255'
    },
    {
      name: 'Thailand',
      label: '+66 (TH)',
      value: '+66'
    },
    {
      name: 'Timor-Leste',
      label: '+670 (TL)',
      value: '+670'
    },
    {
      name: 'Togo',
      label: '+228 (TG)',
      value: '+228'
    },
    {
      name: 'Tokelau',
      label: '+690 (TK)',
      value: '+690'
    },
    {
      name: 'Tonga',
      label: '+676 (TO)',
      value: '+676'
    },
    {
      name: 'Trinidad and Tobago',
      label: '+1868 (TT)',
      value: '+1868'
    },
    {
      name: 'Tunisia',
      label: '+216 (TN)',
      value: '+216'
    },
    {
      name: 'Turkey',
      label: '+90 (TR)',
      value: '+90'
    },
    {
      name: 'Turkmenistan',
      label: '+993 (TM)',
      value: '+993'
    },
    {
      name: 'Turks and Caicos Islands',
      label: '+1649 (TC)',
      value: '+1649'
    },
    {
      name: 'Tuvalu',
      label: '+688 (TV)',
      value: '+688'
    },
    {
      name: 'Uganda',
      label: '+256 (UG)',
      value: '+256'
    },
    {
      name: 'Ukraine',
      label: '+380 (UA)',
      value: '+380'
    },
    {
      name: 'United Arab Emirates',
      label: '+971 (AE)',
      value: '+971'
    },
    {
      name: 'United Kingdom',
      label: '+44 (GB)',
      value: '+44'
    },
    {
      name: 'United States',
      label: '+1 (US)',
      value: '+1'
    },
    {
      name: 'Uruguay',
      label: '+598 (UY)',
      value: '+598'
    },
    {
      name: 'Uzbekistan',
      label: '+998 (UZ)',
      value: '+998'
    },
    {
      name: 'Vanuatu',
      label: '+678 (VU)',
      value: '+678'
    },
    {
      name: 'Venezuela, Bolivarian Republic of Venezuela',
      label: '+58 (VE)',
      value: '+58'
    },
    {
      name: 'Vietnam',
      label: '+84 (VN)',
      value: '+84'
    },
    {
      name: 'Virgin Islands, British',
      label: '+1284 (VG)',
      value: '+1284'
    },
    {
      name: 'Virgin Islands, U.S.',
      label: '+1340 (VI)',
      value: '+1340'
    },
    {
      name: 'Wallis and Futuna',
      label: '+681 (WF)',
      value: '+681'
    },
    {
      name: 'Yemen',
      label: '+967 (YE)',
      value: '+967'
    },
    {
      name: 'Zambia',
      label: '+260 (ZM)',
      value: '+260'
    },
    {
      name: 'Zimbabwe',
      label: '+263 (ZW)',
      value: '+263'
    }
  ]
  export default countryvalues;